export interface BackgroundThemeOption {
  name: string;
  value: string;
}

export const BACKGROUND_THEME_NONE = "none";

export const backgroundThemes: BackgroundThemeOption[] = [
  { name: "None", value: BACKGROUND_THEME_NONE },
  {
    name: "Ultimate Frisbee",
    value: "/assets/background-themes/ultimate-frisbee.svg",
  },
  { name: "Nature Scene", value: "/assets/background-themes/nature.svg" },
  {
    name: "Abstract Design",
    value: "/assets/background-themes/abstract.svg",
  },
  { name: "Calming Visuals", value: "/assets/background-themes/calming.svg" },
  { name: "City Skyline", value: "/assets/background-themes/city.svg" },
  { name: "Beach Sunset", value: "/assets/background-themes/beach.svg" },
  { name: "Mountain View", value: "/assets/background-themes/mountain.svg" },
  {
    name: "Space Exploration",
    value: "/assets/background-themes/space.svg",
  },
];

const LEGACY_BACKGROUND_THEME_MAP: Record<string, string> = {
  "/assets/images/ultimate-frisbee-bg.jpg":
    "/assets/background-themes/ultimate-frisbee.svg",
  "/assets/images/nature-background.jpg":
    "/assets/background-themes/nature.svg",
  "/assets/images/abstract-background.jpg":
    "/assets/background-themes/abstract.svg",
  "/assets/images/calming-background.jpg":
    "/assets/background-themes/calming.svg",
  "/assets/images/city-skyline-bg.jpg": "/assets/background-themes/city.svg",
  "/assets/images/beach-sunset-bg.jpg": "/assets/background-themes/beach.svg",
  "/assets/images/mountain-view-bg.jpg":
    "/assets/background-themes/mountain.svg",
  "/assets/images/space-exploration-bg.jpg":
    "/assets/background-themes/space.svg",
};

export const resolveBackgroundTheme = (value?: string): string => {
  if (!value || value === BACKGROUND_THEME_NONE) {
    return BACKGROUND_THEME_NONE;
  }
  if (LEGACY_BACKGROUND_THEME_MAP[value]) {
    return LEGACY_BACKGROUND_THEME_MAP[value];
  }
  const match = backgroundThemes.find((theme) => theme.value === value);
  return match ? match.value : BACKGROUND_THEME_NONE;
};
